<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Symbole dokumentów</div>
            <div class="text-md text-secondary">Spersonalizuj domyślne symbole dla nowych dokumentów</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <div class="grid grid-cols-2 gap-3 space-y-3" *ngFor="let controls of documentTypesControls">

            <div class="col-span-1" class="flex items-center">
                {{controls.name}}
            </div>

            <div class="col-span-1">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'" >
                    <input type="text" matInput [formControl]="controls.control" placeholder="Symbol">
                 </mat-form-field>
            </div>
     
        </div>
       
    </div>
</div>